import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';

type AbnReturnType = {
  hasValidAbn: boolean;
  redirectOnInvalidAbn: boolean;
};

type ListState = {
  [key: string]: AbnReturnType;
};
type StatusState = {
  [key: number]: string;
};

const list = createReducer<ListState>(
  {},
  {
    [ActionTypes.FETCH_SITE_HAS_ACTIVE_ABN_SUCCESS]: (state, { payload }) =>
      Object.assign({}, state, { [payload.key]: payload })
  }
);

const setStatusForKey = (state, { type, payload }) =>
  Object.assign({}, state, { [payload.key]: type });

const status = createReducer<StatusState>(
  {},
  {
    [ActionTypes.FETCH_SITE_HAS_ACTIVE_ABN_REQUEST]: setStatusForKey,
    [ActionTypes.FETCH_SITE_HAS_ACTIVE_ABN_SUCCESS]: setStatusForKey,
    [ActionTypes.FETCH_SITE_HAS_ACTIVE_ABN_NOT_FOUND]: setStatusForKey,
    [ActionTypes.FETCH_SITE_HAS_ACTIVE_ABN_ERROR]: setStatusForKey
  }
);

export default combineReducers({
  list,
  status
});
